// Utility functions for file upload handling

import apiClient from '../services/api';

export const uploadResume = async (file) => {
  // Simulate file upload to server
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Generate a unique filename
      const timestamp = Date.now();
      const fileExtension = file.name.split('.').pop();
      const filename = `resume_${timestamp}.${fileExtension}`;
      
      // In a real app, this would be the actual file path on the server
      const filePath = `/uploads/resumes/${filename}`;
      
      // Simulate successful upload
      resolve({
        filename: filename,
        path: filePath,
        size: file.size,
        type: file.type
      });
    }, 1000); // Simulate network delay
  });
};

export const RESUME_MAX_BYTES = 50 * 1024 * 1024;

export const validateResumeFile = (file) => {
  const isPdfMime = file.type === 'application/pdf';
  const isPdfExtension = /\.pdf$/i.test(file.name || '');

  if (!isPdfMime && !isPdfExtension) {
    return {
      valid: false,
      error: 'Please upload a PDF file only.'
    };
  }

  if (file.size > RESUME_MAX_BYTES) {
    return {
      valid: false,
      error: 'File size must be 50MB or smaller.'
    };
  }

  return {
    valid: true,
    error: null
  };
};

export const downloadResume = async (applicationId, filename) => {
  if (!applicationId) {
    throw new Error('Application ID is required to download the resume.');
  }

  const { blob, filename: serverFilename } = await apiClient.downloadJobApplicationResume(applicationId);
  const downloadName = filename || serverFilename || 'resume.pdf';
  const objectUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = downloadName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
};
